import { commonCrudOption } from '@/const/crud/commonOption'
import { getToken } from '@/utils/auth'
import { commonSearchFields } from '@/const/crud/commonSearchFields'

// var dic = [
//   {
//     label: '是',
//     value: true
//   },
//   {
//     label: '否',
//     value: false
//   }
// ]
export const getTableOption = (self) => ({
  ...commonCrudOption,
  menuWidth: 100,
  searchIndex: 3,
  searchIcon: true,
  labelWidth: 130,
  searchSpan: 6,
  searchLabelWidth: 120,
  searchMenuSpan: 6,
  tabs: true,
  column: [
    ...commonSearchFields(self),
    {
      minWidth: 120,
      label: '客户类别',
      display: false,
      prop: 'identityType',
      dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/KH-KHLB',
      searchPlaceholder: '请选择',
      search: true,
      searchOrder: 4,
      type: 'select',
      dicHeaders: {
        Authorization: getToken()
      },
      props: {
        children: 'children',
        label: 'name',
        value: 'code'
      },
      control: (val) => {
        if (!val) return
        if (val === 'KH-KHLB-ZRR') {
          return {
            occupation: {
              display: true
            },
            gender: {
              display: true
            },
            workUnit: {
              display: true
            },
            nationality: {
              display: true
            },
            email: {
              display: true
            },
            legalRepresentative: {
              display: false
            },
            legalRepresentativePhone: {
              display: false
            }

          }
        } else if (val === 'KH-KHLB-FR') {
          return {
            occupation: {
              display: false
            },
            gender: {
              display: false
            },
            workUnit: {
              display: false
            },
            email: {
              display: false
            },
            nationality: {
              display: false
            },
            legalRepresentative: {
              display: true
            },
            legalRepresentativePhone: {
              display: true
            }
          }
        }
      }
    },
    {
      minWidth: 120,
      label: '公司名称',
      prop: 'name',
      display: false
    },
    {
      minWidth: 210,
      label: '房屋名称',
      prop: 'houseName',
      display: false,
      suffixIcon: 'el-icon-search',
      readonly: true,
      clearable: false,
      focus: ({ value, column }) => {
        self.openSelectHouse()
      }
    },
    {
      minWidth: 150,
      label: '公司联系电话',
      display: false,
      search: true,
      searchOrder: 8,
      prop: 'mobile'
    },
    {
      minWidth: 150,
      label: '税务登记号',
      display: false,
      prop: 'identityNumber'
    }
  ],
  group: [
    {
      label: '客户信息',
      icon: 'el-icon-user',
      prop: 'basic',
      column: [
        {
          minWidth: 120,
          label: '客户类别',
          prop: 'identityType',
          dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/KH-KHLB',
          search: true,
          searchOrder: 4,
          type: 'select',
          dicHeaders: {
            Authorization: getToken()
          },
          props: {
            children: 'children',
            label: 'name',
            value: 'code'
          },
          rules: [{
            required: true,
            message: '请选择客户类别',
            trigger: 'change'
          }]
        },
        {
          label: '公司名称',
          prop: 'name',
          rules: [{
            required: true,
            message: '请输入公司名称',
            trigger: 'change'
          }]
        },
        {
          label: '是否联名业主',
          prop: 'isCoBranded',
          type: 'radio',
          value: 0,
          addDisplay: false,
          editDisplay: false,
          dicData: [
            { label: '是', value: 1 },
            { label: '否', value: 0 }
          ]
        },
        {
          label: '公司联系电话',
          prop: 'mobile',
          rules: [{
            required: false,
            message: '请输入公司联系电话',
            trigger: 'change'
          }]
        },
        {
          label: '税务登记号',
          prop: 'identityNumber',
          rules: [{
            required: false,
            message: '请输入税务登记号',
            trigger: 'change'
          }]
        },
        {
          label: '固定电话',
          prop: 'fixedPhone',
          rules: [{
            required: false,
            message: '输入固定电话',
            trigger: 'blur'
          }]
        },
        {
          label: '邮箱',
          prop: 'email'
        },
        {
          label: '联系地址',
          prop: 'contactAddress'
        },
        {
          label: '性别',
          prop: 'gender',
          type: 'radio',
          display: false,
          dicData: [
            { label: '男', value: '男' },
            { label: '女', value: '女' }
          ]
        },
        {
          label: '职业',
          display: false,
          prop: 'occupation'
        },
        {
          label: '国籍',
          display: false,
          prop: 'nationality'
        },
        {
          label: '邮政编码',
          prop: 'postalCode'
        },
        {
          label: '收件人',
          prop: 'recipient'
        },
        {
          label: '工作单位',
          display: false,
          prop: 'workUnit'
        },
        {
          label: '法定代表人',
          display: false,
          prop: 'legalRepresentative'
        },
        {
          label: '法定代表人电话',
          display: false,
          prop: 'legalRepresentativePhone'
        }
        // {
        //   label: '证件图片',
        //   prop: 'idCardBackPath',
        //   type: 'upload',
        //   listType: 'picture-card',
        //   action: process.env.VUE_APP_BASE_API + '/api/localStorage/pictures',
        //   propsHttp: {
        //     name: 'name',
        //     url: 'path'
        //   },
        //   withCredentials: true,
        //   headers: {
        //     Authorization: getToken()
        //   }
        // }
      ]
    },
    {
      label: '关联房屋',
      icon: 'el-icon-house',
      column: [
        {
          label: '',
          labelWidth: '0px',
          prop: 'houseCodes',
          formslot: true
        }
      ]
    }
  ]
})

export const getAllCustomerTableOption = (self) => ({
  ...commonCrudOption,
  menuWidth: 100,
  searchIndex: 3,
  searchIcon: true,
  labelWidth: 130,
  searchSpan: 6,
  searchLabelWidth: 120,
  searchMenuSpan: 6,
  tabs: true,
  column: [
    {
      minWidth: 180,
      label: '公司名称',
      prop: 'name',
      search: true,
      searchOrder: 10,
      display: false
    },
    {
      minWidth: 130,
      label: '公司联系电话',
      display: false,
      search: true,
      searchOrder: 8,
      prop: 'mobile'
    },
    {
      minWidth: 210,
      label: '房屋名称',
      prop: 'houseName',
      search: true,
      display: false,
      suffixIcon: 'el-icon-search',
      readonly: true,
      searchOrder: 9,
      clearable: false,
      focus: ({ value, column }) => {
        self.openSelectHouse()
      }
    },
    {
      minWidth: 120,
      label: '客户类别',
      display: false,
      prop: 'identityType',
      dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/KH-KHLB',
      search: true,
      searchOrder: 4,
      type: 'select',
      dicHeaders: {
        Authorization: getToken()
      },
      props: {
        children: 'children',
        label: 'name',
        value: 'code'
      }
    },
    {
      minWidth: 150,
      label: '固定电话',
      display: false,
      prop: 'fixedPhone'
    },
    {
      minWidth: 150,
      label: '税务登记号',
      search: true,
      searchOrder: 7,
      display: false,
      prop: 'identityNumber'
    }
  ]
})
